import * as React from "react";
import Box from "@mui/material/Box";
import ascLines from "./data/AscLinesNumbers";
import ownHouse from "./data/ownHouse";
import friEneNeu from "./data/friEneNeu";
import houseBaseCoordinates from "./data/baseCoordinates";
import { calculateAspect } from "./Utils/aspectCalculator";
import { TranslationContext } from "./context";

export default function AstroChart({
  name,
  gender,
  chartName,
  chartCode,
  place,
  date,
  time,
  planets,
  timeZone,
  asc,
  svgViewBox,
  svgSquareSideLength,
  scale,
}) {
  const [hoverPosition, setHoverPosition] = React.useState({ x: 0, y: 0 });
  const [hoverText, setHoverText] = React.useState("");

  const scaleFactor = parseFloat(scale);

  React.useEffect(() => {
    console.log(parseFloat(scale));
  }, [scale]);

  function detectHoverElement(hoverPosition, elements) {
    for (const element of elements) {
      const { xOri, yOri, width, height } = element;
      const left = parseFloat(xOri) * scaleFactor;
      const top = parseFloat(yOri) * scaleFactor;
      const right = left + parseFloat(width) * scaleFactor;
      const bottom = top + parseFloat(height) * scaleFactor;

      if (
        hoverPosition.x >= left &&
        hoverPosition.x <= right &&
        hoverPosition.y >= top &&
        hoverPosition.y <= bottom
      ) {
        return element; // Return label or any other identifier
      }
    }

    return null;
  }

  const handleHover = (event) => {
    const svgRect = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - svgRect.left;
    const y = event.clientY - svgRect.top;

    setHoverPosition({ x, y });

    const hoveredElement = detectHoverElement(hoverPosition, planets);
    if (hoveredElement) {
      setHoverText({
        planetId: hoveredElement.label.planetNameX,
        houseNumber: hoveredElement.houseNumber,
        xOri: hoveredElement.xOri * scaleFactor,
        yOri: hoveredElement.yOri * scaleFactor,
        width: hoveredElement.width * scaleFactor,
        height: hoveredElement.height * scaleFactor,
        xCenter: hoveredElement.x * scaleFactor,
        yCenter: hoveredElement.y * scaleFactor,
      });
    } else {
      setHoverText("NO");
    }
  };

  // Scale down factor
  function drawRectangles(planetAspects) {
    const rectangles = planetAspects.map((houseNumber) => {
      const { x0, y0 } = houseBaseCoordinates[houseNumber];
      const x = parseFloat(x0) * scaleFactor;
      const y = parseFloat(y0) * scaleFactor;
      const width = 116 * scaleFactor;
      const height = 116 * scaleFactor;

      return (
        <rect
          key={houseNumber}
          x={x}
          y={y}
          width={width}
          height={height}
          fill="rgba(245, 196, 56, 0.4)"
        />
      );
    });

    return rectangles;
  }

  const lineColor = "black";

  const t = React.useContext(TranslationContext);

  return (
    <Box sx={{ p: 2 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        viewBox={svgViewBox}
        width={svgSquareSideLength}
        height={svgSquareSideLength}
        onMouseMove={handleHover}
      >
        {/* Black Lines       can be scale down*/}
        <line
          x1={10 * scaleFactor}
          y1={10 * scaleFactor}
          x2={10 * scaleFactor}
          y2={474 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={10 * scaleFactor}
          y1={474 * scaleFactor}
          x2={474 * scaleFactor}
          y2={474 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={474 * scaleFactor}
          y1={474 * scaleFactor}
          x2={474 * scaleFactor}
          y2={10 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={474 * scaleFactor}
          y1={474 * scaleFactor}
          x2={474 * scaleFactor}
          y2={10 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={474 * scaleFactor}
          y1={10 * scaleFactor}
          x2={10 * scaleFactor}
          y2={10 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={10 * scaleFactor}
          y1={126 * scaleFactor}
          x2={474 * scaleFactor}
          y2={126 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={10 * scaleFactor}
          y1={242 * scaleFactor}
          x2={126 * scaleFactor}
          y2={242 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={358 * scaleFactor}
          y1={242 * scaleFactor}
          x2={474 * scaleFactor}
          y2={242 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={10 * scaleFactor}
          y1={358 * scaleFactor}
          x2={474 * scaleFactor}
          y2={358 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={126 * scaleFactor}
          y1={10 * scaleFactor}
          x2={126 * scaleFactor}
          y2={474 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={242 * scaleFactor}
          y1={10 * scaleFactor}
          x2={242 * scaleFactor}
          y2={126 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={242 * scaleFactor}
          y1={358 * scaleFactor}
          x2={242 * scaleFactor}
          y2={474 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        <line
          x1={358 * scaleFactor}
          y1={10 * scaleFactor}
          x2={358 * scaleFactor}
          y2={474 * scaleFactor}
          strokeWidth="2"
          stroke={lineColor}
        />
        {/* Name     font can be scaled */}
        <text
          x={242 * scaleFactor}
          y={146 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={16 * scaleFactor}
          fontFamily="sans-serif"
          fontWeight="bold"
          style={{ pointerEvents: "none" }}
        >
          {name}
        </text>
        {/* Gender   */}
        <text
          x={322 * scaleFactor}
          y={180 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={16 * scaleFactor}
          fontFamily="sans-serif"
          style={{ pointerEvents: "none" }}
        >
          {gender}
        </text>
        {/* Date Of Birth */}
        <text
          x={216 * scaleFactor}
          y={180 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={16 * scaleFactor}
          fontFamily="sans-serif"
          style={{ pointerEvents: "none" }}
        >
          {date.format("DD-MM-YYYY")}
        </text>
        {/* Place Of Birth */}
        <text
          x={242 * scaleFactor}
          y={214 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={16 * scaleFactor}
          fontFamily="sans-serif"
          style={{ pointerEvents: "none" }}
        >
          {place}
        </text>

        {/* Time Of Birth */}
        <text
          x={221 * scaleFactor}
          y={248 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={16 * scaleFactor}
          fontFamily="sans-serif"
          style={{ pointerEvents: "none" }}
        >
          {time}
        </text>
        {/* Time Zone */}
        <text
          x={327 * scaleFactor}
          y={248 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={16 * scaleFactor}
          fontFamily="sans-serif"
          style={{ pointerEvents: "none" }}
        >
          {timeZone}
        </text>
        {/* जय श्री राम */}
        <text
          x={242 * scaleFactor}
          y={287 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={19 * scaleFactor}
          fontFamily="sans-serif"
          fontWeight="bold"
          style={{ pointerEvents: "none" }}
        >
          जय श्री राम
        </text>
        {/* Chart Code */}
        <text
          x={247 * scaleFactor}
          y={328 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={20 * scaleFactor}
          fontFamily="sans-serif"
          fontWeight="bold"
          style={{ pointerEvents: "none" }}
        >
          {chartCode}
        </text>
        {/* Chart Name */}
        <text
          x={180 * scaleFactor}
          y={328 * scaleFactor}
          text-anchor="middle"
          alignment-baseline="middle"
          fontSize={16 * scaleFactor}
          fontFamily="sans-serif"
          style={{ pointerEvents: "none" }}
        >
          {chartName}
        </text>
        {/* Asc Lines     scale down */}
        {asc && (
          <>
            <line
              xmlns="http://www.w3.org/2000/svg"
              x1={ascLines[asc][1].x1 * scaleFactor}
              y1={ascLines[asc][1].y1 * scaleFactor}
              x2={ascLines[asc][1].x2 * scaleFactor}
              y2={ascLines[asc][1].y2 * scaleFactor}
              strokeWidth={2}
              stroke="#000000"
            />

            <line
              xmlns="http://www.w3.org/2000/svg"
              x1={ascLines[asc][2].x1 * scaleFactor}
              y1={ascLines[asc][2].y1 * scaleFactor}
              x2={ascLines[asc][2].x2 * scaleFactor}
              y2={ascLines[asc][2].y2 * scaleFactor}
              strokeWidth={2}
              stroke="#000000"
            />

            {ascLines[asc][3].map((number, index) => (
              <text
                key={index}
                x={number.x * scaleFactor}
                y={number.y * scaleFactor}
                fontSize={16 * scaleFactor}
                fontFamily="sans-serif"
                style={{ pointerEvents: "none" }}
              >
                {number.label}
              </text>
            ))}
          </>
        )}
        {/* Planet Label */}
        {planets.map((planet, index) => {
          // const firstFourLetters = planet.label.substring(0, 4);
          // const restOfLabel = planet.label.substring(4);

          const planetNameY = planet.label.planetNameX;
          const planetDegreeY = planet.label.planetDegreeX;
          const planetEmojiY1 = planet.label.planetEmojiX1;
          const planetEmojiY2 = planet.label.planetEmojiX2;
          const planetEmojiY3 = planet.label.planetEmojiX3;

          return (
            <text
              key={index}
              x={planet.x * scaleFactor}
              y={planet.y * scaleFactor}
              alignmentBaseline="middle"
              textAnchor="middle"
              fontSize={`${planet.fontSize * scaleFactor}px`}
              fontFamily="sans-serif"
              fontWeight="bold"
              style={{
                pointerEvents: "none",

                fill: hoverText.planetId
                  ? friEneNeu[hoverText.planetId][planetNameY] || "#000000"
                  : "#000000",
              }}
            >
              <tspan fontSize={(planet.fontSize + 4) * scaleFactor}>
                {t(planetNameY)}
              </tspan>
              <tspan fontSize={(planet.fontSize - 4) * scaleFactor}>
                {` ` + planetDegreeY}
              </tspan>
              <tspan fontSize={(planet.fontSize + 2) * scaleFactor}>
                {` ${planetEmojiY1}${planetEmojiY2}${planetEmojiY3}`}
              </tspan>
            </text>
          );
        })}

        {/* OwnHouse Hover => Own House Indication */}
        {ownHouse[hoverText.planetId] &&
          ownHouse[hoverText.planetId].map((house, index) => (
            <text
              key={index}
              x={house.x * scaleFactor}
              y={house.y * scaleFactor}
              alignment-baseline="middle"
              text-anchor="middle"
              fontSize={14 * scaleFactor}
              fontFamily="sans-serif"
              style={{ pointerEvents: "none" }}
            >
              {house.label}
            </text>
          ))}

        {/* Planet Aspect Light */}
        {drawRectangles(
          calculateAspect(hoverText.planetId, hoverText.houseNumber)
        )}
        {/* Logo */}
        <image
          x={268 * scaleFactor}
          y={303 * scaleFactor}
          width={90 * scaleFactor}
          height={50 * scaleFactor}
          href="https://t3.ftcdn.net/jpg/02/03/91/52/360_F_203915296_BO7X2PBZo9kusPhHyDccmqiCq8kMgC0i.jpg"
        />
      </svg>

      {/* <p>
        Hover position: {hoverPosition.x.toFixed(1)},{" "}
        {hoverPosition.y.toFixed(1)}
      </p>
      <p>Hover detect: {JSON.stringify(hoverText)}</p>

      <p> Input Planet ID : {hoverText.planetId} </p>
      <p> Input House Number : {hoverText.houseNumber} </p>
      <p>
        Aspects Calculator:{" "}
        {JSON.stringify(
          calculateAspect(hoverText.planetId, hoverText.houseNumber)
        )}
      </p> */}
    </Box>
  );
}
